import React from 'react';

/**
 * Shared shell for the 3 legal pages — keeps them styled consistently
 * and adds a "DRAFT — Pending Solicitor Review" banner on each.
 * Uses dark brand palette + readable typography.
 */
export default function LegalShell({ title, lastUpdated, version = 'v1 DRAFT', children }) {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-200">
      <header className="border-b border-zinc-800 bg-black">
        <div className="max-w-3xl mx-auto px-5 py-5 flex items-center justify-between gap-3">
          <a
            href="/"
            className="text-sm text-zinc-400 hover:text-white"
            data-testid="legal-back-home"
          >
            ← Flipping Friends
          </a>
          <nav className="flex gap-4 text-xs text-zinc-400">
            <a href="/terms" className="hover:text-white" data-testid="legal-nav-terms">
              Terms
            </a>
            <a href="/privacy" className="hover:text-white" data-testid="legal-nav-privacy">
              Privacy
            </a>
            <a
              href="/community-guidelines"
              className="hover:text-white"
              data-testid="legal-nav-community"
            >
              Community
            </a>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-2">{title}</h1>
        <p className="text-sm text-zinc-500 mb-6">
          {version} · Last updated: {lastUpdated}
        </p>

        <div
          className="rounded-lg p-4 mb-8"
          style={{ background: 'rgba(255,215,0,0.08)', border: '1px solid #FFD70055' }}
          data-testid="legal-draft-banner"
        >
          <p className="text-sm">
            <strong style={{ color: '#FFD700' }}>⚠ DRAFT — Pending Solicitor Review.</strong> This
            document is a working draft produced by the Flipping Friends team and has not yet
            been reviewed by a qualified solicitor. It does not constitute legal advice. A
            reviewed and approved v2 will replace this version before payments are accepted.
          </p>
        </div>

        <div className="prose-legal space-y-5 leading-relaxed text-[15.5px]">{children}</div>

        <footer className="mt-14 pt-8 border-t border-zinc-800 text-xs text-zinc-500">
          <p>
            <strong className="text-zinc-300">Flipping Friends Ltd</strong> (pending incorporation) ·
            UK
          </p>
          <p className="mt-1">
            Contact:{' '}
            <a
              href="mailto:marcus@flippingfriends.co.uk"
              className="text-[#00D26A] hover:underline"
            >
              marcus@flippingfriends.co.uk
            </a>
          </p>
          <p className="mt-3 text-[11px]">
            Companies House number and ICO registration number will be published here once
            registration is complete.
          </p>
        </footer>
      </main>
    </div>
  );
}
